import React from 'react';
import { Link } from 'react-router-dom';
import './Posts.css';

/**
 * Posts
 * Renders a grid of blog post cards from real data (see
 * src/assets/data/blog/posts.json), passed in via the `posts` prop.
 * Each post gets its own crawlable, shareable URL (?post=slug) so
 * search engines can index individual articles rather than one
 * generic /blog page.
 */
const Posts = ({ posts = [] }) => {
  if (!posts.length) {
    return (
      <div className='posts-container'>
        <p className='posts-empty'>No posts published yet — check back soon.</p>
      </div>
    );
  }

  return (
    <div className='posts-container'>
      <div className='posts-grid'>
        {posts.map(post => (
          <article key={post.id} className='post-card glass-dark'>
            <div className='post-header'>
              <span className='post-category'>{post.category}</span>
              <span className='post-date'>
                {new Date(post.date).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric'
                })}
              </span>
            </div>
            <h3 className='post-title'>{post.title}</h3>
            <p className='post-excerpt'>{post.excerpt}</p>
            <Link to={`/blog?post=${post.slug}`} className='post-link'>
              Read More →
            </Link>
          </article>
        ))}
      </div>
    </div>
  );
};

export default Posts;
